import React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {People, HomeWork, AddLocation,PhotoLibrary,ThumbUp, Lock, ExpandLess, ExpandMore, Search, CameraAlt, Elevator, Person, GroupWork, SettingsRemote, ViewQuilt, More, Logout, Settings, Redeem, Inventory, AutoAwesome, AccountBalanceWallet, Business, Face, HeadsetMic, Email, Approval} from '@mui/icons-material';
import {Image,Tv,WbSunny,Visibility,ListAlt,Poll,Info,AccountCircle,Help} from '@mui/icons-material';
import UserMgmt from './usermgmt/UserMgmt';
import {Button} from '@mui/material';
import DeviceMgmt from './devicemgmt/DeviceMgmt';
import GroupMgmt from './devicemgmt/GroupMgmt';
import RemoteDeviceMgmt from './devicemgmt/RemoteDeviceMgmt';
import ElevatorMgmt from './elevator/ElevatorMgmt';
import ElevatorStatistics from './elevator/ElevatorStatistics';
import ContentLibrary from './contentmgmt/ContentLibrary';
import Playlist from './contentmgmt/Playlist'
import { Divider } from '@mui/material';
import EditText from './contentmgmt/EditText';
import LayoutDesigner from './devicemgmt/LayoutDesigner';
import WeatherInfo from './contentmgmt/WeatherInfo';
import SurveyMgmt from './contentmgmt/SurveyMgmt';
import Support from './about/Support';
import AuditLog from './about/AuditLog';
import EditUserAccount from './about/EditUserAccount';
import {Equalizer,Videocam,Security,AvTimer,RssFeed} from '@mui/icons-material';
import SecurityMgmtIPCamera from './security/SecurityMgmtIPCamera';
import SecurityMgmt from './security/SecurityMgmt';
import Countdown from './contentmgmt/Countdown';
import FloorDirectory from './contentmgmt/FloorDirectory';
import RSSCreator from './contentmgmt/RSSCreator';
import Newsticker from './contentmgmt/Newsticker';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FormattedMessage} from 'react-intl';
import ReactCountryFlag from "react-country-flag";
import ServiceTechnician from './elevator/ServiceTechnician';
import JobDefinition from './elevator/JobDefinition';
import Jobs from './elevator/Jobs';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import {Work,Storage} from '@mui/icons-material';
import Whatsapp from './contentmgmt/Whatsapp';
import OnPremisesServers from './devicemgmt/OnPremisesServers';
import * as ETVConstants from './ETVConstants';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import GeoAdConfig from './advertising/GeoAdConfig';
import GeoAdApproval from './advertising/GeoAdApproval';
import GeoAdBookings from './advertising/GeoAdBookings';
import GeoAdPayments from './advertising/GeoAdPayments';
import AccessMgmt from './building/AccessMgmt';
import CardMgmt from './security/CardMgmt';
import DeviceFloorMgmt from './building/DeviceFloorMgmt';
import FaceTerminalMgmt from './security/FaceTerminalMgmt';
import IntercomMgmt from './elevator/intercom/IntercomMgmt';
import EmailAdapter from './contentmgmt/MessagingAdapter';
import ApprovalLibrary from './contentmgmt/ApprovalLibrary';
import { CalendarIcon } from '@mui/x-date-pickers';
import ContentPlanner from './contentmgmt/ContentPlanner';
import LocationDefinition from './building/LocationDefinition';
import BuildingMessages from './building/BuildingMessages';
import ETVPageDemo from './about/ETVPageDemo';
// import ArchitectureIcon from '@mui/icons-material/Architecture'; // Used by the hidden Page Style Demo menu entry.

const list_width = '270px';
const portalStyles = {
  root: {
    background:'white',
    display:'flex',
    margin:0,
    color:'#1C1C1C',
    width:'100%',
    minHeight:'100vh',
    boxSizing: "border-box",
  },

  sidebar: {
    position:'fixed',
    inset:'0 auto 0 0',
    zIndex:10,
    width:list_width,
    display:'flex',
    flexDirection:'column',
    background:'#fff',
    borderRight:'1px solid #e4e8ee',
    boxSizing:'border-box',
  },

  list: {
    background:'white',
    color:'#1C1C1C',
    flex:'1 1 auto',
    minHeight:0,
    overflowY:'auto',
    scrollbarWidth:'none',
    msOverflowStyle:'none',
    '&::-webkit-scrollbar': {
      display:'none',
    },
    paddingTop:4,
    paddingBottom:8,
  },

  nested: {
    paddingLeft: '50px',
    color:'black',
  },

  content: {
    zIndex:0,
    background: 'white',
    marginLeft:list_width,
    marginTop:0,
    flex: "1 1 auto", 
    width:`calc(100% - ${list_width})`,
    minHeight:'100vh',
    minWidth: 0,
    boxSizing: "border-box",
    display: "flex",              
    justifyContent: "flex-start",
    alignItems: "stretch",
    overflow:'visible',
  },
};


export default function Portal(props) {
  const [openIntercom, setOpenIntercom] = React.useState(false);
  const handleClickIntercom = () => {
    setOpenIntercom(!openIntercom);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  // content
  const [open1, setOpen1] = React.useState(false);
  const handleClick1 = () => {
    setOpenIntercom(false);
    setOpen1(!open1);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  // device
  const [open2, setOpen2] = React.useState(false);
  const handleClick2 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(!open2);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open3, setOpen3] = React.useState(false);
  const handleClick3 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(!open3);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open4, setOpen4] = React.useState(false);
  const handleClick4 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(!open4);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open5, setOpen5] = React.useState(false);
  const handleClick5 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(!open5);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open6, setOpen6] = React.useState(false);
  const handleClick6 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(!open6);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open7, setOpen7] = React.useState(false);
  const handleClick7 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(!open7);
    setOpen8(false);
    setOpen9(false);
    setOpen10(false);
  };

  const [open8, setOpen8] = React.useState(false);
  const handleClick8 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(!open8);
    setOpen9(false);
    setOpen10(false);
  };

  const [open9, setOpen9] = React.useState(false);
  const handleClick9 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(!open9);
    setOpen10(false);
  };

  const [open10, setOpen10] = React.useState(false);
  const handleClick10 = () => {
    setOpenIntercom(false);
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen8(false);
    setOpen9(false);
    setOpen10(!open10);
  };


  const [curPage, setPage] = React.useState(10);
  const showPage = (whichPage) => {
    if(ETVConstants.ON_PREMISE_VERSION && [72,74,76,77].includes(whichPage)) {
      return;
    }
    //console.log("showPage="+whichPage);
    setPage(whichPage);
  }

  const setLang = (lang) => {
    var accessToken = localStorage.getItem("etv.access_token");
    var reqUserID = localStorage.getItem("etv.user_id");
    var url = ETVConstants.getServerBase()+'/useradmin?action=set_language&user_id='+props.user_id+"&lang="+lang;
    fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
    .then((response) => response.json())
    .then((responseJson) => {
      if(responseJson["result"]) {
        props.langCallback(lang);
      }
    })
    .catch((error) => {
    });
  }

  function trans( msgID) {
    return <FormattedMessage id={msgID} defaultMessage={"["+msgID+"]"} />
  }

///////////////////////////////////////////////////////////////////////////////
// roles
// [library,marketplace,playlist,create_text,weather_info,surveys,coupons,reservations,device_configuration,remote_management,layout_designer,user_management,elevator_config,elevator_statistics]
///////////////////////////////////////////////////////////////////////////////

  function hasCategory( cat) {
    //console.log("hasCategory ("+cat+")? all="+props.roles);
    for(var i=0; i<props.roles.length; i++) {
      //console.log("hasCategory="+cat+" ["+props.roles[i]+"]");
      if(props.roles[i].indexOf("."+cat+".")>0) {
        //console.log("...yes");
        return true;
      }
    }
    //console.log("...no");
    return false;
  }

  function hasRole(role) {
    for(var i=0; i<props.roles.length; i++) {
      var r = props.roles[i].substring(props.roles[i].lastIndexOf(".")+1,props.roles[i].length);
      if(r===role) return true;
    }
    return false;
    //return props.roles.includes(role);
  }

  // library,marketplace,playlist,create_text,weather_info,surveys,coupons,reservations
  function hasContentCategory() {
    return hasCategory("content");
  }

  function hasDeviceCategory() {
    //console.log("======>"+props.status);
    if(props.status==='marketplace_provider') return false;
    //return true; //everyone shall have the device grouping
    return hasCategory("device");
  }

  function hasUserCategory() {
    return hasCategory("usermgmt");
  }

  function hasAdvertisingCategory() {
    //return true;
    return hasCategory("advertising");
  }

  function hasElevatorCategory() {
    return hasCategory("elevator");
  }

  function hasSecurityCategory() {
    return hasCategory("security");
  }

  function hasBuildingDefinitionCategory() {
    return hasCategory("building");
  }

  function isJobAdmin() {
    // maybe used in future
    return false;
  }

  function canRelease() {
    return false;
  }

  function canReview() {
    return false;
  }

  function isSuperAdmin() {
    return (props.status === "superadmin");
  }

  return (
    <Box sx={portalStyles.root}>
      <Box sx={portalStyles.sidebar}>
        <Box sx={{px:2.75,pt:2.75,pb:2,borderBottom:'1px solid',borderColor:'divider'}}>
          <Box component="img" src={ETVConstants.getLogo()} alt="Elevator TV" sx={{display:'block',width:'100%',maxWidth:220,height:86,objectFit:'contain',objectPosition:'left center'}}/>
          <Box sx={{display:'flex',alignItems:'center',gap:1,mt:1.25,minWidth:0}}>
            <AccountCircle color="primary"/>
            <Typography variant="body2" noWrap title={props.username} sx={{fontWeight:600}}>{props.username}</Typography>
          </Box>
        </Box>

      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        sx={portalStyles.list} >

        {!hasContentCategory()?<span/>:<div>

            <ListItemButton onClick={handleClick1} style={open1?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Image />
              </ListItemIcon>
              <ListItemText primary={trans("content")} sx={{cursor: 'pointer'}} />
              {open1 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open1} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("playlist")?<span/>:
                  <ListItemButton onClick={()=>showPage(10)} sx={portalStyles.nested}>
                    <ListItemIcon><FormatListNumberedIcon/></ListItemIcon>
                    <ListItemText primary={trans("playlist")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("playlist")?<span/>:
                  <ListItemButton onClick={()=>showPage(195)} sx={portalStyles.nested}>
                    <ListItemIcon><CalendarIcon/></ListItemIcon>
                    <ListItemText primary={trans("content_planner")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("library")?<span/>:
                  <ListItemButton onClick={()=>showPage(11)} sx={portalStyles.nested}>
                    <ListItemIcon><PhotoLibrary/></ListItemIcon>
                    <ListItemText primary={trans("library")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("library") || ETVConstants.ON_PREMISE_VERSION ?<span/>:
                  <ListItemButton onClick={()=>showPage(194)} sx={portalStyles.nested}>
                    <ListItemIcon><Approval/></ListItemIcon>
                    <ListItemText primary={trans("approvals")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }                
                {!hasRole("create_text")?<span/>:
                  <ListItemButton onClick={()=>showPage(12)} sx={portalStyles.nested}>
                    <ListItemIcon><Image/></ListItemIcon>
                    <ListItemText primary={trans("templates")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("create_text")?<span/>:
                  <ListItemButton onClick={()=>showPage(13)} sx={portalStyles.nested}>
                    <ListItemIcon><More/></ListItemIcon>
                    <ListItemText primary={trans("ticker_text")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("weather_info") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(14)} sx={portalStyles.nested}>
                    <ListItemIcon><WbSunny/></ListItemIcon>
                    <ListItemText primary={trans("weather_info")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
                }
                {!hasRole("surveys") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(15)} sx={portalStyles.nested}>
                    <ListItemIcon><Poll/></ListItemIcon>
                    <ListItemText primary={trans("surveys")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("create_text") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(17)} sx={portalStyles.nested}>
                    <ListItemIcon><AvTimer/></ListItemIcon>
                    <ListItemText primary={trans("countdown_ticker")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("playlist") || !hasDeviceCategory() ?<span/>:
                  <ListItemButton onClick={()=>showPage(18)} sx={portalStyles.nested}>
                    <ListItemIcon><ListAlt/></ListItemIcon>
                    <ListItemText primary={trans("floor_directory")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("create_text") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(19)} sx={portalStyles.nested}>
                    <ListItemIcon><RssFeed/></ListItemIcon>
                    <ListItemText primary={trans("rss_feeds")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {/*
                {!hasRole("whatsapp") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(192)} sx={portalStyles.nested}>
                    <ListItemIcon><WhatsApp/></ListItemIcon>
                    <ListItemText primary={trans("whatsapp")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                */}
                {!hasRole("library") || ETVConstants.ON_PREMISE_VERSION ?<span/>:
                  <ListItemButton onClick={()=>showPage(193)} sx={portalStyles.nested}>
                    <ListItemIcon><Email/></ListItemIcon>
                    <ListItemText primary={trans("messaging")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }

              </List>
            </Collapse>
            <Divider/>
        </div>}

        {!hasDeviceCategory()?<span/>:<div>
            <ListItemButton onClick={handleClick2} style={open2?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Tv/>
              </ListItemIcon>
              <ListItemText primary={trans("screens")} sx={{cursor: 'pointer'}} />
              {open2 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open2} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("device_configuration")?<span/>:
                  <ListItemButton onClick={()=>showPage(20)} sx={portalStyles.nested}>
                    <ListItemIcon><Tv/></ListItemIcon>
                    <ListItemText primary={trans("screens")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("device_configuration")?<span/>:
                  <ListItemButton onClick={()=>showPage(23)} sx={portalStyles.nested}>
                    <ListItemIcon><GroupWork/></ListItemIcon>
                    <ListItemText primary={trans("grouping")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
                }
                {!hasRole("remote_management")?<span/>:
                  <ListItemButton onClick={()=>showPage(21)} sx={portalStyles.nested}>
                    <ListItemIcon><SettingsRemote/></ListItemIcon>
                    <ListItemText primary={trans("remote_management")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("layout_designer")?<span/>:
                  <ListItemButton onClick={()=>showPage(22)} sx={portalStyles.nested}>
                    <ListItemIcon><ViewQuilt/></ListItemIcon>
                    <ListItemText primary={trans("layout_designer")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
                }
                {!isSuperAdmin() || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(24)} sx={portalStyles.nested}>
                    <ListItemIcon><Storage/></ListItemIcon>
                    <ListItemText primary={trans("OnPremisesServers")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
                }
              </List>
            </Collapse>
            <Divider/>
        </div>
        }

        {!ETVConstants.ON_PREMISE_VERSION && hasBuildingDefinitionCategory() && <div>
          <ListItemButton onClick={handleClick10} style={open10?{background:'#e9eff2'}:{}}>
            <ListItemIcon>
              <Business />
            </ListItemIcon>
            <ListItemText primary={trans("building")} sx={{cursor: 'pointer'}} />
            {open10 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open10} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                <ListItemButton onClick={()=>showPage(76)} sx={portalStyles.nested}>
                      <ListItemIcon><AddLocation/></ListItemIcon>
                      <ListItemText primary={trans("location_definition")} sx={{cursor: 'pointer'}}/>
                </ListItemButton>
                <ListItemButton onClick={()=>showPage(72)} sx={portalStyles.nested}>
                    <ListItemIcon><Business/></ListItemIcon>
                    <ListItemText primary={trans("floors_definition")} sx={{cursor: 'pointer'}} />
                </ListItemButton>
                <ListItemButton onClick={()=>showPage(74)} sx={portalStyles.nested}>
                      <ListItemIcon><Lock/></ListItemIcon>
                      <ListItemText primary={trans("device_floor_definition")} sx={{cursor: 'pointer'}}/>
                </ListItemButton>
                <ListItemButton onClick={()=>showPage(77)} sx={portalStyles.nested}>
                      <ListItemIcon><Email/></ListItemIcon>
                      <ListItemText primary={trans("received_messages")} sx={{cursor: 'pointer'}}/>
                </ListItemButton>
            </List>
          </Collapse>
          <Divider/>
        </div>}

        {!hasUserCategory()?<span/>:<div>
          <ListItemButton onClick={handleClick3} style={open3?{background:'#e9eff2'}:{}}>
            <ListItemIcon>
              <People />
            </ListItemIcon>
            <ListItemText primary={trans("user_mgmt")} sx={{cursor: 'pointer'}} />
            {open3 ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open3} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {!hasRole("user_management")?<span/>:
                  <ListItemButton onClick={()=>showPage(30)} sx={portalStyles.nested}>
                    <ListItemIcon><Person/></ListItemIcon>
                    <ListItemText primary={trans("overview")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
              }
            </List>
          </Collapse>
          <Divider/>
        </div>}

        {isJobAdmin() ? <div>
            <ListItemButton onClick={handleClick4} style={open4?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Work />
              </ListItemIcon>
              <ListItemText primary="Jobs" sx={{cursor: 'pointer'}}/>
              {open4 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open4} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

                <ListItemButton onClick={()=>showPage(40)} sx={portalStyles.nested}>
                  <ListItemIcon><FormatListBulletedIcon/></ListItemIcon>
                  <ListItemText primary="Overview" sx={{cursor: 'pointer'}}/>
                </ListItemButton>

                {canRelease()?
                  <ListItemButton onClick={()=>showPage(41)} sx={portalStyles.nested}>
                    <ListItemIcon><ThumbUp/></ListItemIcon>
                    <ListItemText primary="Release" sx={{cursor: 'pointer'}} />
                  </ListItemButton>:<span/>}

                {canReview()?
                  <ListItemButton onClick={()=>showPage(42)} sx={portalStyles.nested}>
                    <ListItemIcon><Visibility/></ListItemIcon>
                    <ListItemText primary="Review" sx={{cursor: 'pointer'}} />
                  </ListItemButton>:<span/>}

                <ListItemButton onClick={()=>showPage(43)} sx={portalStyles.nested}>
                    <ListItemIcon><Search/></ListItemIcon>
                    <ListItemText primary="Database" sx={{cursor: 'pointer'}}/>
                </ListItemButton>

              </List>
            </Collapse>
            <Divider/>
            </div>
        :<span/>}

        {!isJobAdmin()?<div/>:<div>
            <ListItemButton onClick={handleClick5} style={open5?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <HomeWork/>
              </ListItemIcon>
              <ListItemText primary="Installations" sx={{cursor: 'pointer'}} />
              {open5 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open5} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton onClick={()=>showPage(50)} sx={portalStyles.nested}>
                  <ListItemIcon><FormatListBulletedIcon/></ListItemIcon>
                  <ListItemText primary="Overview" sx={{cursor: 'pointer'}} />
                </ListItemButton>
                <ListItemButton onClick={()=>showPage(51)} sx={portalStyles.nested}>
                  <ListItemIcon><AddLocation/></ListItemIcon>
                  <ListItemText primary="Map" sx={{cursor: 'pointer'}} />
                </ListItemButton>
              </List>
            </Collapse>
            <Divider/>
          </div>}

          {!hasAdvertisingCategory() || ETVConstants.ON_PREMISE_VERSION?<div/>:<div>
            <ListItemButton onClick={handleClick9} style={open9?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Redeem/>
              </ListItemIcon>
              <ListItemText primary="boostly" sx={{cursor: 'pointer'}} />
              {open9 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open9} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("advertising_approvals")?<span/>:
                  <ListItemButton onClick={()=>showPage(91)} sx={portalStyles.nested}>
                    <ListItemIcon><AutoAwesome/></ListItemIcon>
                    <ListItemText primary={trans("approvals")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("advertising_approvals")?<span/>:
                  <ListItemButton onClick={()=>showPage(92)} sx={portalStyles.nested}>
                    <ListItemIcon><Inventory/></ListItemIcon>
                    <ListItemText primary="Bookings" sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("advertising_approvals")?<span/>:
                  <ListItemButton onClick={()=>showPage(93)} sx={portalStyles.nested}>
                    <ListItemIcon><AccountBalanceWallet/></ListItemIcon>
                    <ListItemText primary="Payments" sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
                {!hasRole("advertising_definition")?<span/>:
                  <ListItemButton onClick={()=>showPage(90)} sx={portalStyles.nested}>
                    <ListItemIcon><Settings/></ListItemIcon>
                    <ListItemText primary={trans("settings")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
                }
              </List>
            </Collapse>
            <Divider/>
          </div>}


          {!hasElevatorCategory()?<span/>:<div>
            <ListItemButton onClick={handleClick6} style={open6?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Elevator/>
              </ListItemIcon>
              <ListItemText primary={trans("elevator")} sx={{cursor: 'pointer'}} />
              {open6 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open6} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!hasRole("elevator_config")?<span/>:
                    <ListItemButton onClick={()=>showPage(60)} sx={portalStyles.nested}>
                      <ListItemIcon><Elevator/></ListItemIcon>
                      <ListItemText primary={trans("elevators")} sx={{cursor: 'pointer'}}/>
                    </ListItemButton>
                }
                {/*
                {!hasRole("elevator_config")?<span/>:
                    <ListItemButton onClick={()=>showPage(62)} sx={portalStyles.nested}>
                      <ListItemIcon><Engineering/></ListItemIcon>
                      <ListItemText primary={trans("service_technician")} sx={{cursor: 'pointer'}}/>
                    </ListItemButton>
                }
                */}
                {/*}
                {!hasRole("elevator_config")?<span/>:
                    <ListItemButton onClick={()=>showPage(63)} sx={portalStyles.nested}>
                      <ListItemIcon><Work/></ListItemIcon>
                      <ListItemText primary={trans("job_definition")} sx={{cursor: 'pointer'}}/>
                    </ListItemButton>
                }
                */}
                {/*
                {!hasRole("elevator_config")?<span/>:
                    <ListItemButton onClick={()=>showPage(64)} sx={portalStyles.nested}>
                      <ListItemIcon><Build/></ListItemIcon>
                      <ListItemText primary={trans("jobs")} sx={{cursor: 'pointer'}}/>
                    </ListItemButton>
                }
                */}
                {!hasRole("elevator_statistics") || ETVConstants.ON_PREMISE_VERSION?<span/>:
                  <ListItemButton onClick={()=>showPage(61)} sx={portalStyles.nested}>
                    <ListItemIcon><Equalizer/></ListItemIcon>
                    <ListItemText primary={trans("statistics")} sx={{cursor: 'pointer'}}/>
                  </ListItemButton>
                }
              </List>
            </Collapse>
            <Divider/>
          </div>}

          {hasRole("elevator_config") && !ETVConstants.ON_PREMISE_VERSION && <div>
            <ListItemButton onClick={handleClickIntercom} style={openIntercom?{background:'#e9eff2'}:{}}>
              <ListItemIcon><HeadsetMic/></ListItemIcon>
              <ListItemText primary={trans("intercom")} sx={{cursor: 'pointer'}} />
              {openIntercom ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openIntercom} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton selected={curPage===65} onClick={()=>showPage(65)} sx={portalStyles.nested}>
                  <ListItemIcon><Settings/></ListItemIcon>
                  <ListItemText primary={<FormattedMessage id="configuration" defaultMessage="Configuration" />} />
                </ListItemButton>
                <ListItemButton selected={curPage===66} onClick={()=>showPage(66)} sx={portalStyles.nested}>
                  <ListItemIcon><ListAlt/></ListItemIcon>
                  <ListItemText primary={<FormattedMessage id="en81_alarm_overview" defaultMessage="EN81-28 alarm overview" />} />
                </ListItemButton>
                <ListItemButton selected={curPage===67} onClick={()=>showPage(67)} sx={portalStyles.nested}>
                  <ListItemIcon><VerifiedUser/></ListItemIcon>
                  <ListItemText primary={<FormattedMessage id="alarm_path_supervision" defaultMessage="Alarm Path Supervision" />} />
                </ListItemButton>
              </List>
            </Collapse>
            <Divider/>
          </div>}

          {!hasSecurityCategory() || ETVConstants.ON_PREMISE_VERSION?<span/>:<div>
            <ListItemButton onClick={handleClick7} style={open7?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Security/>
              </ListItemIcon>
              <ListItemText primary={trans("security_mgmt")} sx={{cursor: 'pointer'}} />
              {open7 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open7} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                    {!hasRole("card_management")?<span/>:
                      <ListItemButton onClick={()=>showPage(73)} sx={portalStyles.nested}>
                        <ListItemIcon><Lock/></ListItemIcon>
                        <ListItemText primary={trans("card_management")} sx={{cursor: 'pointer'}}/>
                      </ListItemButton>
                    }
                    {!hasRole("card_management")?<span/>:
                      <ListItemButton onClick={()=>showPage(75)} sx={portalStyles.nested}>
                        <ListItemIcon><Face/></ListItemIcon>
                        <ListItemText primary={trans("face_recognition_terminals")} sx={{cursor: 'pointer'}}/>
                      </ListItemButton>
                    }
                    {!hasRole("cam")?<span/>:
                      <ListItemButton onClick={()=>showPage(70)} sx={portalStyles.nested}>
                        <ListItemIcon><Videocam/></ListItemIcon>
                        <ListItemText primary={trans("ip_camera")} sx={{cursor: 'pointer'}} />
                      </ListItemButton>
                    }
                    {!hasRole("cam")?<span/>:
                      <ListItemButton onClick={()=>showPage(71)} sx={portalStyles.nested}>
                        <ListItemIcon><CameraAlt/></ListItemIcon>
                        <ListItemText primary={trans("usb_camera")} sx={{cursor: 'pointer'}}/>
                      </ListItemButton>
                    }
              </List>
            </Collapse>
            <Divider/>
          </div>}

          <div>
            <ListItemButton onClick={handleClick8} style={open8?{background:'#e9eff2'}:{}}>
              <ListItemIcon>
                <Info/>
              </ListItemIcon>
              <ListItemText primary={trans("about")} sx={{cursor: 'pointer'}}/>
              {open8 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open8} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                  <ListItemButton onClick={()=>showPage(80)} sx={portalStyles.nested}>
                    <ListItemIcon><AccountCircle/></ListItemIcon>
                    <ListItemText primary={trans("my_details")} sx={{cursor: 'pointer'}} />
                  </ListItemButton>
                  { ETVConstants.ON_PREMISE_VERSION?<span/>:
                    <ListItemButton onClick={()=>showPage(82)} sx={portalStyles.nested}>
                      <ListItemIcon><Help/></ListItemIcon>
                      <ListItemText primary={trans("support")} sx={{cursor: 'pointer'}}/>
                    </ListItemButton>
                  }
                  {!hasRole("audit_log")?<span/>:
                    <ListItemButton onClick={()=>showPage(83)} sx={portalStyles.nested}>
                      <ListItemIcon><VerifiedUser/></ListItemIcon>
                      <ListItemText primary={trans("audit_logs")} sx={{cursor: 'pointer'}}/>
                    </ListItemButton>
                  }
                  {/* Page Style Demo is intentionally hidden from navigation for now.
                  <ListItemButton onClick={()=>showPage(84)} sx={portalStyles.nested}>
                    <ListItemIcon><ArchitectureIcon/></ListItemIcon>
                    <ListItemText primary="Page style demo" sx={{cursor:'pointer'}}/>
                  </ListItemButton>
                  */}
              </List>
            </Collapse>
          </div>
      </List>
        <Box sx={{px:2.25,py:2,borderTop:'1px solid',borderColor:'divider',bgcolor:'#fff'}}>
          <FormControl fullWidth size="small" sx={{mb:1.25}}>
            <Select id="language" value={props.lang || 'en'} onChange={(e)=>setLang(e.target.value)} sx={{bgcolor:'#fff'}}>
              <MenuItem value="en"><ReactCountryFlag countryCode="us" svg />&nbsp;English</MenuItem>
              <MenuItem value="de"><ReactCountryFlag countryCode="de" svg />&nbsp;Deutsch</MenuItem>
              <MenuItem value="fr"><ReactCountryFlag countryCode="fr" svg />&nbsp;Français</MenuItem>
              <MenuItem value="jp"><ReactCountryFlag countryCode="jp" svg />&nbsp;日本語</MenuItem>
              <MenuItem value="vn"><ReactCountryFlag countryCode="vn" svg />&nbsp;Tiếng Việt</MenuItem>
              <MenuItem value="th"><ReactCountryFlag countryCode="th" svg />&nbsp;ไทย</MenuItem>
            </Select>
          </FormControl>
          <Button fullWidth variant="outlined" startIcon={<Logout/>} onClick={()=>props.loggedInCallback(false)} sx={{minHeight:44,textTransform:'none',fontWeight:600}}>{trans('logout')}</Button>
        </Box>
      </Box>
      <Box component="main" sx={portalStyles.content}>
          {
            curPage===10 ?<Playlist lang={props.lang} user_id={props.user_id} children={props.children} roles={props.roles} />:
            curPage===11 ?<ContentLibrary lang={props.lang} user_id={props.user_id} children={props.children} marketplace={false} roles={props.roles} />:
            curPage===12 ?<EditText lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===13 ?<Newsticker lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===14 ?<WeatherInfo lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===15 ?<SurveyMgmt lang={props.lang} user_id={props.user_id} />:
            curPage===17 ?<Countdown lang={props.lang} user_id={props.user_id} />:
            curPage===18 ?<FloorDirectory lang={props.lang} user_id={props.user_id} />:

            curPage===19 ?<RSSCreator lang={props.lang} user_id={props.user_id} />:
            curPage===192 ?<Whatsapp lang={props.lang} user_id={props.user_id} />:
            curPage===193 ?<EmailAdapter lang={props.lang} user_id={props.user_id} />:
            curPage===194 ?<ApprovalLibrary lang={props.lang} user_id={props.user_id} />:
            curPage===195 ?<ContentPlanner lang={props.lang} user_id={props.user_id} />:

            curPage===20 ?<DeviceMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} status={props.status} />:
            curPage===21 ?<RemoteDeviceMgmt lang={props.lang} user_id={props.user_id} status={props.status} />:
            curPage===22 ?<LayoutDesigner lang={props.lang} user_id={props.user_id} />:
            curPage===23 ?<GroupMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} status={props.status} />:
            curPage===24 ?<OnPremisesServers lang={props.lang} user_id={props.user_id} />:

            curPage===30 ?<UserMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} status={props.status} />:

            curPage===60 ?<ElevatorMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===61 ?<ElevatorStatistics lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===62 ?<ServiceTechnician lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===63 ?<JobDefinition lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===64 ?<Jobs lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            [65,66,67].includes(curPage) ?<IntercomMgmt key={curPage} view={curPage===66 ? 'alarms' : curPage===67 ? 'supervision' : 'configuration'} lang={props.lang} user_id={props.user_id} roles={props.roles} />:

            curPage===70 ?<SecurityMgmtIPCamera lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===71 ?<SecurityMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===72 && !ETVConstants.ON_PREMISE_VERSION ?<AccessMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===73 ?<CardMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===74 && !ETVConstants.ON_PREMISE_VERSION ?<DeviceFloorMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===75 ?<FaceTerminalMgmt lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===76 && !ETVConstants.ON_PREMISE_VERSION ?<LocationDefinition lang={props.lang} user_id={props.user_id} roles={props.roles} />:
            curPage===77 && !ETVConstants.ON_PREMISE_VERSION ?<BuildingMessages lang={props.lang} user_id={props.user_id} roles={props.roles} />:

            curPage===80 ?<EditUserAccount lang={props.lang} user_id={props.user_id} username={props.username} status={props.status} roles={props.roles} />:
            curPage===82 ?<Support lang={props.lang} user_id={props.user_id} />:
            curPage===83 ?<AuditLog lang={props.lang} user_id={props.user_id} />:
            curPage===84 ?<ETVPageDemo />:

            curPage===90 && !ETVConstants.ON_PREMISE_VERSION ?<GeoAdConfig lang={props.lang} user_id={props.user_id} />:
            curPage===91 && !ETVConstants.ON_PREMISE_VERSION ?<GeoAdApproval lang={props.lang} user_id={props.user_id} />:
            curPage===92 && !ETVConstants.ON_PREMISE_VERSION ?<GeoAdBookings lang={props.lang} user_id={props.user_id} />:
            curPage===93 && !ETVConstants.ON_PREMISE_VERSION ?<GeoAdPayments lang={props.lang} user_id={props.user_id} />:
            <span/>
          }
      </Box>
    </Box>
  );
}
